import React, { useEffect, useState } from "react";
import UnitAdmin from "../Layout/UnitAdmin/UnitAdmin";
import LeadAudit from "../Layout/AuditAdmin/LeadAudit";
import { AuthenticatedTemplate, UnauthenticatedTemplate,useIsAuthenticated } from "@azure/msal-react";
import { getToken } from "../auth/authConfig";
import LoadingScreen from "../reusables/LoadingScreen";
import Login from "../auth/Login";
import TechReviewerAudit from "../Layout/TechReviewer/TechReviewerAudit";

const Audit = () => {
  const [groupName, setGroupName] = useState(localStorage.getItem("GroupName"));
  const [loading,setloadingUser] = useState(true);
  const isAuthenticated = useIsAuthenticated();

  const getUserinfo = async () => {
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/getUserInfoV2`;
    const token = await getToken();
    const maxRetries = 3;
  
    setloadingUser(true);
  
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
  
        if (response.status === 200) {
          const json = await response.json();
          const info = json?.user;
          const role = info?.group_name;
          const company = info?.company;
  
          setGroupName(role);
          localStorage.setItem("GroupName", role);
          localStorage.setItem("company", company);
          setloadingUser(false);
          return;
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (err) {
        console.log(`Attempt ${attempt} failed:`, err);
  
        if (attempt === maxRetries) {
          console.error("All retry attempts failed.");
          setloadingUser(false);
        }
      }
    }
  };
  
  useEffect(() => {
    if (isAuthenticated) {
      getUserinfo();
    }
  }, [isAuthenticated]);
  

  return (
    <div>
      <AuthenticatedTemplate>
        {loading && (
          <div style={{ height: "100vh" }}>
            <LoadingScreen />
          </div>
        )}

        {!loading && (
          <div>
            <>
              {groupName === "Unit Admin" ? (
                <>
                  <UnitAdmin />
                </>
              ) : groupName === "Super Admin" ? (
                <div style={{ height: "100vh" }}>
                  <div
                    style={{
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                      height: "100%",
                      display: "grid",
                      fontSize: "30px",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        display: "grid",
                        alignItems: "center",
                        alignContent: "center",
                        height: "100%",
                      }}
                    >
                      <h1 class="w3-jumbo w3-animate-top w3-center">
                        <code>Access Denied</code>
                      </h1>
                      <h4 class="w3-center w3-animate-right">
                        You have Unauthorized to this form
                      </h4>
                      <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
                      <h6 class="w3-center w3-animate-zoom">
                        error code:403 forbidden
                      </h6>
                    </div>
                  </div>
                </div>
              ) 
              : groupName === "Tech Reviewer" ? (
                <>
                  <TechReviewerAudit />
                </>
                
              )
              : groupName === "CB Admin (Tech Reviewer)" ? (
                <>
                  <TechReviewerAudit />
                </>
                
              )
              : groupName === "Lead Auditor" ? (
                <>
                  {" "}
                  <LeadAudit />
                </>
              ) : groupName === "CB Admin" ? (
                <>
                  {" "}
                  <LeadAudit />
                </>
              ) : (
                <>
                  <div style={{ height: "100vh" }}>
                    <div
                      style={{
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center",
                        height: "100%",
                        display: "grid",
                        fontSize: "30px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          display: "grid",
                          alignItems: "center",
                          alignContent: "center",
                          height: "100%",
                        }}
                      >
                        <h1 class="w3-jumbo w3-animate-top w3-center">
                          <code>Access Denied</code>
                        </h1>
                        <h4 class="w3-center w3-animate-right">
                          You have Unauthorized to this form
                        </h4>
                        <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
                        <h6 class="w3-center w3-animate-zoom">
                          error code:403 forbidden
                        </h6>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          </div>
        )}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Audit;
